const MICRO_PER_CENT = 1000000

type MicroAmountToFixed = (
  microAmount?: number,
  fractionDigits?: number
) => string | undefined
export const microAmountToFixed: MicroAmountToFixed = (
  microAmount,
  fractionDigits = 2
) => {
  if (!microAmount) return undefined
  return (microAmount / MICRO_PER_CENT).toFixed(fractionDigits)
}

type ParseMicro = (value?: string) => number | undefined
export const parseMicro: ParseMicro = value => {
  if (!value) return undefined
  const float = parseFloat(value)
  if (Number.isNaN(float)) return undefined
  return float * MICRO_PER_CENT
}
